// removed by extract-text-webpack-plugin
module.exports = {"searchBar":"_4p-qup3gR8iNajEi41UiJ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsSearchBar/PlaylistsSearchBar.scss
// module id = 1363
// module chunks = 1